/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export {
  getStringFromEnv,
  getBooleanFromEnv,
  getNumberFromEnv,
  getStringListFromEnv,
} from './environment';
export { _globalThis } from '../../common/globalThis';
export { SDK_INFO } from './sdk-info';

/**
 * @deprecated Use performance directly.
 */
export const otperformance: { now(): number; readonly timeOrigin: number } =
  performance;
